/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
//Custom libraries
import MiniCartPopperContent from "./MiniCartPopperContent";
//Redux
import { numItemsSelector } from "../../redux/selectors/order";
//UI
import { Hidden } from "@material-ui/core";
import {
  StyledAccountPopper,
  StyledButton,
  StyledTypography,
  StyledHeaderActions,
} from "@hcl-commerce-store-sdk/react-component";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

interface MiniCartProps {
  id: string;
  open: boolean;
  handleClick: Function;
  handleClose: Function;
}

/**
 * MiniCart component
 * displays number of cart items icon
 * @param props
 */
const MiniCart = React.forwardRef<HTMLButtonElement | null, MiniCartProps>(
  (props: any, ref: any) => {
    const { id, open, handleClick, handleClose } = props;
    const { t } = useTranslation();
    const numItems = useSelector(numItemsSelector);
    const [arrowRef, setArrowRef] = useState<any>(null);

    return (
      <>
        <StyledButton
          id="header-mini-cart-button"
          data-testid="header-mini-cart-button"
          ref={ref}
          className="header-actionsButton btn-mini-cart"
          variant="text"
          color="secondary"
          onClick={handleClick}>
          <StyledHeaderActions>
            <ShoppingCartIcon className="iconCarrito" />
            <StyledTypography
              className="minishopcart_total textoPrincipal"
              variant="body1"
              component="p">
              {t("MiniCart.Items", { count: numItems })}
            </StyledTypography>
            <StyledTypography
              className="textoPrincipal"
              variant="body1"
              component="span">
              <Hidden mdUp>Carrito de compras</Hidden>
              <Hidden mdDown>Carrito</Hidden>
            </StyledTypography>
          </StyledHeaderActions>
        </StyledButton>

        <StyledAccountPopper
          id={id}
          open={open}
          anchorEl={ref?.current}
          onClose={handleClose}
          placement="bottom-end"
          modifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: false,
              boundariesElement: "scrollParent",
            },
            hide: {
              enabled: true,
            },
            arrow: {
              enabled: true,
              element: arrowRef,
            },
          }}
          className="mini-cart-popper">
          <span className="arrow" ref={setArrowRef} />
          <MiniCartPopperContent handleClose={handleClose} />
        </StyledAccountPopper>
      </>
    );
  }
);

export default MiniCart;
